import {
  Module,
  VuexModule,
  Mutation,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  DOCUMENT_DOWNLOAD,
  DOCUMENT_FETCH,
  DOCUMENT_CREATE,
  DOCUMENT_UPDATE,
  DOCUMENT_DELETE,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'document' })
export default class DocumentUrl extends VuexModule {
  dataFile: any = {};

  documentApi: any = [];

  @Mutation
  mutateDocumentFile(data: any) {
    this.dataFile = data;
  }

  @Action({ commit: 'mutateDocumentFile' })
  DownloadDocument(params) {
    return Vue.axios({
      url: BASE_URL + DOCUMENT_DOWNLOAD,
      responseType: 'blob',
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const dataFile = data;
        return {
          dataFile,
        };
      })
      .catch((err) => err);
  }

  @Mutation
  mutatedocumentApi(data: any) {
    this.documentApi = data;
  }

  @Action({ commit: 'mutatedocumentApi' })
  FetchDocumentApi(params = {}) {
    return Vue.axios({
      url: BASE_URL + DOCUMENT_FETCH,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action
  CreateDocumentApi(params) {
    return Vue.axios({
      url: BASE_URL + DOCUMENT_CREATE,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data.status)
      .catch((err) => err);
  }

  @Action
  UpdateDocumentApi(params) {
    return Vue.axios({
      url: BASE_URL + DOCUMENT_UPDATE,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data.status)
      .catch((err) => err);
  }

  @Action
  DeleteDocumentApi(params) {
    return Vue.axios({
      url: BASE_URL + DOCUMENT_DELETE,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data.status)
      .catch((err) => err);
  }
}
